import {Component, DestroyRef, OnInit, ViewChild} from '@angular/core';

import {FormsModule, NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {HeaderComponent} from '../templates/header/header.component';
import {FooterComponent} from '../templates/footer/footer.component';
import {SurveyorDetailsComponent} from './surveyor-details/surveyor-details.component';
import {FieldRecordLodgementComponent} from './field-record-lodgement/field-record-lodgement.component';
import {FieldRecordDetailsComponent} from './field-record-details/field-record-details.component';
import {FieldRecordSubjectPlansComponent} from './field-record-subject-plans/field-record-subject-plans.component';
import {FieldRecordFormerTenureComponent} from './field-record-former-tenure/field-record-former-tenure.component';
import {FieldRecordLocalitiesComponent} from './field-record-localities/field-record-localities.component';
import {FieldRecordAddressComponent} from './field-record-address/field-record-address.component';
import {FieldRecordSurveyDetailsComponent} from './field-record-survey-details/field-record-survey-details.component';
import {FieldRecordAttachmentsComponent} from './field-record-attachments/field-record-attachments.component';
import {FieldRecordWapcComponent} from './field-record-wapc/field-record-wapc.component';
import {LookupService} from '../common/service/lookup.service';
import {PlanModelService} from '../common/service/plan-model.service';
import {NgEventBus} from 'ng-event-bus';
import {PlanModel} from '../common/service/plan-model.model';
import {FirmSettingsService} from '../common/service/firm-settings.service';
import {NlrpLodgeFieldRecordService} from './lodge-field-record.service';
import {NlrpFieldRecordLocalitiesService} from '../lodge-field-record/field-record-localities/field-record-localities.service';
import {AuthenticatorService} from '../common/service/authenticator.service';
import {clean} from '../common/service/data-util';
import {FieldRecordLodgementErrorModalService} from '../common/component/modal/field-record-lodgement-errors-modal/field-record-lodgement-errors-modal.service';
import {FieldRecordLodgementSuccessModalService} from '../common/component/modal/field-record-lodgement-success-modal/field-record-lodgement-success-modal.service';
import {ConfirmationModalService} from '../common/component/modal';
import {PermissionsService} from '../common/service/permissions.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'nlr-plan-lodge-field-record',
    imports: [
        FormsModule,
        HeaderComponent,
        FooterComponent,
        SurveyorDetailsComponent,
        FieldRecordLodgementComponent,
        FieldRecordDetailsComponent,
        FieldRecordSubjectPlansComponent,
        FieldRecordFormerTenureComponent,
        FieldRecordLocalitiesComponent,
        FieldRecordAddressComponent,
        FieldRecordSurveyDetailsComponent,
        FieldRecordAttachmentsComponent,
        FieldRecordWapcComponent
    ],
    templateUrl: './lodge-field-record.component.html',
    styleUrl: './lodge-field-record.component.scss'
})
export class LodgeFieldRecordComponent implements OnInit {
    @ViewChild('lodgeFieldRecordForm')
    lodgeFieldRecordForm: NgForm;

    title = 'Field Record Information';
    lodgeFieldRecordPermissions = ['LODGE_FIELD_RECORD'];
    planModel: PlanModel = undefined;
    model = {};
    fieldRecordPurposes = [];
    fieldRecordLodgementTypes = [];
    selectedPurpose = [];
    selectedLodgementType = [];
    formerTenureSubjectOfPlans = undefined;
    parentPlanTypes = undefined;
    planTypes = undefined;
    fieldRecordAttachmentTypes = undefined;
    childValidationResults: boolean[] = [];
    totalChildNumber: number = 4;

    @ViewChild('fieldRecordWapcForm') fieldRecordWapcForm: FieldRecordWapcComponent;
    @ViewChild('fieldRecordLocalitiesForm') fieldRecordLocalitiesForm: FieldRecordLocalitiesComponent;
    @ViewChild('fieldRecordAddressForm') fieldRecordAddressForm: FieldRecordAddressComponent;
    @ViewChild('surveyorDetailsForm') surveyorDetailsForm: SurveyorDetailsComponent;
    @ViewChild('fieldRecordLodgeForm') fieldRecordLodgeForm: FieldRecordLodgementComponent;
    @ViewChild('fieldRecordDetailsForm') fieldRecordDetailsForm: FieldRecordLodgementComponent;
    @ViewChild('fieldRecordSubjectPlans') fieldRecordSubjectPlans: FieldRecordSubjectPlansComponent;
    @ViewChild('fieldRecordSurveyDetails') fieldRecordSurveyDetails: FieldRecordSurveyDetailsComponent;
    @ViewChild('fieldRecordAttachments') fieldRecordAttachments: FieldRecordAttachmentsComponent;
    @ViewChild('fieldRecordFormerTenure') fieldRecordFormerTenure: FieldRecordFormerTenureComponent;

    constructor(
        private router: Router,
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private firmSettingService: FirmSettingsService,
        private nlrpLodgeFieldRecordService: NlrpLodgeFieldRecordService,
        private nlrpFieldRecordLocalitiesService: NlrpFieldRecordLocalitiesService,
        private authenticatorService: AuthenticatorService,
        private fieldRecordLodgementErrorModalService: FieldRecordLodgementErrorModalService,
        private fieldRecordLodgementSuccessModalService: FieldRecordLodgementSuccessModalService,
        private confirmationModalService: ConfirmationModalService,
        private permissionsService: PermissionsService,
        private destroyRef: DestroyRef
    ) {}

    onModelChanged(newModel: PlanModel) {
        this.planModel = {...newModel};
        this.model = {...newModel};
    }

    updateValidationResult(index: number, isValid: boolean) {
        this.childValidationResults[index] = isValid;
    }

    ngOnInit(): void {
        this.firmSettingService.getFirmEmailAddress().subscribe({
            next: firmEmailAddress => {
                console.debug('Firm Settings Service getFirmEmailAddress response:', firmEmailAddress);

                this.planModelService.getModel().lodgementReceiptEmailAddress = firmEmailAddress;
            },
            error: error => {
                this.planModelService.getModel().lodgementReceiptEmailAddress = this.authenticatorService.getUsername();
                console.error('Firm Settings Service getFirmEmailAddress error:', error);
            },
            complete: () => {
                console.debug('Lodgement receipt email address set to ' + this.planModelService.getModel().lodgementReceiptEmailAddress);
            }
        });

        if (this.lookupService.lookupsLoaded) {
            this.initialiseLookups();
        } else {
            this.eventBus
                .on('nlr:lookups-loaded')
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                    this.initialiseLookups();
                });
        }
    }

    initialiseLookups() {
        this.getPlanModel();
        this.fieldRecordPurposes = this.lookupService.getLookups('fieldRecordPurpose');
        this.fieldRecordLodgementTypes = this.lookupService.getLookups('fieldRecordLodgementType');
        this.formerTenureSubjectOfPlans = this.lookupService.getLookups('formerTenureSubjectOfPlan');
        this.parentPlanTypes = this.lookupService.getLookups('parentPlanType');
        this.planTypes = this.lookupService.getLookups('planType');
        this.nlrpLodgeFieldRecordService.updatePlanTypes(this.planTypes);
        this.fieldRecordAttachmentTypes = this.lookupService.getLookups('fieldRecordAttachmentType');
        this.nlrpLodgeFieldRecordService.updateAttachmentTypes(this.fieldRecordAttachmentTypes);
        this.selectedPurpose = this.getSelectedPurpose();
    }

    getPlanLodgementModel() {
        return this.planModelService.getModel();
    }

    getPlanModel() {
        this.planModelService.initPlanModel();
        this.model = this.planModelService.getModel();
    }

    showSurveyorDetails() {
        return true;
    }

    showFieldRecordLodgement() {
        return this.fieldRecordLodgementTypes;
    }

    showFieldRecordDetails() {
        return this.fieldRecordPurposes && this.formerTenureSubjectOfPlans;
    }

    showFieldRecordSubjectPlans() {
        const selectedPurpose = this.getSelectedPurpose();
        return this.getSelectedPurpose()
            ? this.planModelService.getModel().lodgeType && selectedPurpose && selectedPurpose.subjectPlan !== 'Implied'
            : false;
    }

    showFieldRecordFormerTenure() {
        const selectedPurpose = this.getSelectedPurpose();
        return (
            this.getPlanLodgementModel().lodgeType &&
            this.planTypes &&
            this.parentPlanTypes &&
            this.formerTenureSubjectOfPlans &&
            selectedPurpose &&
            selectedPurpose.formerTenure !== 'Implied' &&
            selectedPurpose.formerTenure !== 'NotCollected'
        );
    }

    showFieldRecordLocalities() {
        var selectedPurpose = this.getSelectedPurpose();
        return (
            this.planModelService.getModel().lodgeType && this.planTypes && this.parentPlanTypes && this.formerTenureSubjectOfPlans && selectedPurpose
        );
    }

    showFieldRecordAddress() {
        const selectedPurpose = this.getSelectedPurpose();
        return (
            selectedPurpose &&
            selectedPurpose.address !== 'NotCollected' &&
            this.nlrpFieldRecordLocalitiesService.getSanitizedLocalities(this.planModelService.getModel().localities)
        );
    }

    showFieldRecordAttachments() {
        return this.planModelService.getModel().lodgeType && this.fieldRecordAttachmentTypes && this.getPlanLodgementModel().purpose;
    }

    showFieldRecordSurveyDetails = function () {
        var selectedPurpose = this.getSelectedPurpose();
        return this.planModelService.getModel().lodgeType && selectedPurpose;
    };

    showFieldRecordWapc() {
        const selectedPurpose = this.getSelectedPurpose();

        return this.planModelService.getModel().lodgeType && selectedPurpose && selectedPurpose.planningApproval;
    }

    getSelectedPurpose() {
        if (this.fieldRecordPurposes.length > 0) {
            return this.fieldRecordPurposes.filter(v => {
                return v.id === this.planModelService.getModel().purpose;
            })[0];
        }
    }

    getSelectedLodgementType() {
        if (this.fieldRecordLodgementTypes) {
            return this.fieldRecordLodgementTypes.filter(v => {
                return v.id === this.planModelService.getModel().lodgeType;
            })[0];
        }
    }

    save() {
        this.surveyorDetailsForm['submitted'] = true;
        this.fieldRecordLodgeForm['submitted'] = true;
        this.fieldRecordDetailsForm['submitted'] = true;
        if (this.fieldRecordSubjectPlans) this.fieldRecordSubjectPlans['submitted'] = true;
        if (this.fieldRecordSurveyDetails) this.fieldRecordSurveyDetails['submitted'] = true;
        if (this.fieldRecordWapcForm) this.fieldRecordWapcForm['submitted'] = true;
        if (this.fieldRecordAttachments) this.fieldRecordAttachments['submitted'] = true;
        if (this.fieldRecordFormerTenure) this.fieldRecordFormerTenure['submitted'] = true;
        if (this.fieldRecordLocalitiesForm) this.fieldRecordLocalitiesForm['submitted'] = true;
        if (this.fieldRecordAddressForm) this.fieldRecordAddressForm['submitted'] = true;

        if (
            this.childValidationResults.length >= this.totalChildNumber &&
            this.childValidationResults.every(isValid => isValid) &&
            this.lodgeFieldRecordForm.valid
        ) {
            const subs = this.nlrpLodgeFieldRecordService.save(this.getSanitizedModel()).subscribe({
                next: res => {
                    const newModel = res ? structuredClone(res) : {};

                    if (newModel.purpose) {
                        const fieldRecordPurpose = this.fieldRecordPurposes.filter(v => {
                            return v.id === newModel.purpose;
                        })[0];
                        if (fieldRecordPurpose) {
                            newModel.category = fieldRecordPurpose.category;
                        }
                    }

                    this.planModelService.updateModel(newModel);

                    this.fieldRecordLodgementSuccessModalService.showModal('Success', 'Field record lodged successfully!').subscribe(() => {
                        this.router.navigate(['redirect-home']);
                    });
                },
                error: data => {
                    if (Array.isArray(data['error'])) {
                        this.fieldRecordLodgementErrorModalService.showModal(data['error']);
                    } else {
                        this.fieldRecordLodgementErrorModalService.showModal([], data['error']);
                    }
                }
            });

            this.eventBus.cast('nlr:busy', subs);
        }
    }

    getSanitizedModel() {
        const sanitizedModel = clean(structuredClone(this.planModelService.getModel()));
        if (sanitizedModel.category) {
            delete sanitizedModel.category;
        }

        if (sanitizedModel.subjectPlans) {
            const subjectPlanMap = sanitizedModel.subjectPlans.reduce((acc: {[key: string]: any}, v: any) => {
                const key = JSON.stringify(v);
                if (!acc[key]) {
                    acc[key] = v;
                }
                return acc;
            }, {});

            sanitizedModel.subjectPlans.length = 0;
            Array.prototype.push.apply(
                sanitizedModel.subjectPlans,
                Object.keys(subjectPlanMap).map(k => {
                    return subjectPlanMap[k];
                })
            );
        }

        if (sanitizedModel.attachments && sanitizedModel.attachments.length) {
            const filteredAttachments = sanitizedModel.attachments.filter((a: any) => {
                return Object.keys(a).length;
            });
            sanitizedModel.attachments.length = 0;
            if (filteredAttachments.length) {
                Array.prototype.push.apply(sanitizedModel.attachments, filteredAttachments);
            }
        }

        return sanitizedModel;
    }

    adjustFontSize(increment: number) {
        const minFontSize = 12;
        const baseFontSize = 14;
        const maxFontSize = 20;
        const bodyElt = document.body;
        const fontSize = parseInt(bodyElt.style.fontSize) || baseFontSize;
        const newFontSize = fontSize + increment;

        if (newFontSize >= minFontSize && newFontSize <= maxFontSize) {
            bodyElt.style.fontSize = newFontSize + 'px';
        }
    }

    cancel() {
        console.debug(this.title + ' : cancel');
        this.confirmationModalService
            .showModal({
                title: 'Warning',
                confirmationText: 'You are about to lose all changes. Are you sure you wish to continue?'
            })
            .subscribe(action => {
                if (action === 'yes') {
                    this.router.navigate(['/redirect-home']);
                }
            });
    }

    hasLodgeFieldRecordPermission() {
        return this.permissionsService.getPermissions(this.lodgeFieldRecordPermissions).length > 0;
    }
}
